<template>
  <div>
    <CameraCalDetailDialog
      :dialog="showCameraCalDetail"
      :cameraCal = "cameraCal"
      @close="closeCameraCalDetailDialog"
    >
    </CameraCalDetailDialog>

    <v-card>
      <v-toolbar
        color="teal"
      >
        <v-toolbar-title>
          Camera Calibrations
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <div style="width: 300px;">
          <v-text-field
            placeholder="filter camera serial number"
            single-line
            v-model="filterCameraSerialNumber"
            append-icon="filter_list"
            class="mt-4 mr-3"
            @input="filter"
          >
          </v-text-field>
        </div>
      </v-toolbar>

      <v-data-table
        class="mt-5"
        single-select
        :footer-props="{ disableItemsPerPage: true, }"
        :headers="headers"
        :loading="busy"
        :items="cameraCals"
        :items-per-page="10"
        :server-items-length="serverItemsLength"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="showCameraCalDetailDialog(item)" v-on="on">zoom_in</v-icon>
            </template>
            <span>View Calibration Details</span>
          </v-tooltip>
        </template>
      </v-data-table>

    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import CameraCalDetailDialog from '../components/camera_cal/CameraCalDetailDialog.vue';

export default {
  components: {
    CameraCalDetailDialog,
  },

  data() {
    return {
      headers: [
        {
          text: 'Operator',
          align: 'left',
          sortable: false,
          value: 'Operator',
          width: 150,
        },
        {
          text: 'Version',
          align: 'left',
          sortable: false,
          value: 'Version',
          width: 100,
        },
        {
          text: 'Date',
          align: 'left',
          sortable: false,
          value: '_date',
          width: 200,
        },
        {
          text: 'Left Boards',
          align: 'left',
          sortable: false,
          value: '_leftSerialNumbers',
          width: 250,
        },
        {
          text: 'Right Boards',
          align: 'left',
          sortable: false,
          value: '_rightSerialNumbers',
          width: 250,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
        },
      ],
      options: {},
      busy: false,
      serverItemsLength: 0,
      cameraCals: [],
      showCameraCalDetail: false,
      filterCameraSerialNumber: '',
      cameraCal: {},
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      const options = {
        method: 'get',
        url: `/read/camera_cals/v1/?page=${this.options.page || 1}&filterSerialNumber=${this.filterCameraSerialNumber}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.cameraCals = res.data.docs.map((cur) => {
            const {
              Date, createdAt, updatedAt, ...rest
            } = cur;
            const d = moment(Date);
            const c = moment(createdAt);
            const u = moment(updatedAt);

            const leftSerialNumbers = cur.LeftBoards.reduce((acc, clb) => {
              acc.push(clb.SerialNumber);
              return acc;
            }, []);

            const rightSerialNumbers = cur.RightBoards.reduce((acc, crb) => {
              acc.push(crb.SerialNumber);
              return acc;
            }, []);

            return Object.assign({}, {
              _date: d.local().format('YYYY-MM-DD HH:mm:ss'),
              createdAt: c.local().format('YYYY-MM-DD HH:mm:ss'),
              updatedAt: u.local().format('YYYY-MM-DD HH:mm:ss'),
              _leftSerialNumbers: leftSerialNumbers.join(', '),
              _rightSerialNumbers: rightSerialNumbers.join(', '),
            }, rest);
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    filter() {
      this.getData();
    },

    showCameraCalDetailDialog(cameraCal) {
      this.cameraCal = cameraCal;
      this.showCameraCalDetail = true;
    },

    closeCameraCalDetailDialog() {
      this.showCameraCalDetail = false;
      this.cameraCal = {};
    },
  },
};
</script>

<style scoped>
</style>
